import { Icon, IconProps } from "./Icon";

export function IconBell(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 23a2 2 0 0 1-2-2H9a3 3 0 0 0 6 0h-1a2 2 0 0 1-2 2Zm9.14-7A1.14 1.14 0 0 1 20 14.87v-4.28A8.36 8.36 0 0 0 12.5 2V0h-1v2A8.35 8.35 0 0 0 4 10.59v4.28A1.14 1.14 0 0 1 2.86 16a.87.87 0 0 0-.86.86v2.21a.91.91 0 0 0 .89.92h18.22a.91.91 0 0 0 .89-.92v-2.2a.87.87 0 0 0-.86-.87ZM21 19H3v-2a2.14 2.14 0 0 0 2-2.14v-4.27C5 6.4 8.14 3 12 3s7 3.4 7 7.59v4.28A2.14 2.14 0 0 0 21 17Z" />
    </Icon>
  );
}
